export const TownsTokenConfig = {
    sizes: {
        xxs: {
            containerSize: 60,
            addressSize: 42,
            addressRadius: 8,
            badgeSize: 36,
            badgeRadius: 4,
            fontSize: 4.5,
            maxTextHeight: 24,
            borderRadius: 'xs',
        },
        xs: {
            containerSize: 92,
            addressSize: 72,
            addressRadius: 8,
            badgeSize: 60,
            badgeRadius: 10,
            fontSize: 6,
            maxTextHeight: 42,
            borderRadius: 'sm',
        },
        sm: {
            containerSize: 130,
            addressSize: 105,
            addressRadius: 20,
            badgeSize: 85,
            badgeRadius: 16,
            fontSize: 8,
            maxTextHeight: 42,
            borderRadius: 'md',
        },
        md: {
            containerSize: 150,
            addressSize: 135,
            addressRadius: 10,
            badgeSize: 108,
            badgeRadius: 14,
            fontSize: 8,
            maxTextHeight: 80,
            borderRadius: 'md',
        },
        sideBar: {
            containerSize: 8 * 21,
            addressSize: 8 * 17.5,
            addressRadius: 8 * 2,
            badgeSize: 8 * 14,
            badgeRadius: 14,
            fontSize: 10,
            maxTextHeight: 80,
            borderRadius: 'md',
        },
        lg: {
            containerSize: 200,
            addressSize: 190,
            addressRadius: 20,
            badgeSize: 160,
            badgeRadius: 16,
            fontSize: 12,
            maxTextHeight: 80,
            borderRadius: 'md',
        },
        xl: {
            containerSize: 270,
            addressSize: 270,
            addressRadius: 32,
            badgeSize: 216,
            badgeRadius: 16,
            fontSize: 15,
            maxTextHeight: 120,
            borderRadius: 'md',
        },
    },
} as const

export type TownsTokenSize = keyof typeof TownsTokenConfig.sizes
